import Wrapper from '../Wrapper';
import { useSuspenseQuery } from '@tanstack/react-query';
import { upcomingInvoiceQueryOptions } from '../../utils/queryOptions';
import dayjs from 'dayjs';


const UpcomingInvoiceOverview = () => {

  const upcomingInvoice = useSuspenseQuery(upcomingInvoiceQueryOptions());

  let Euro = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' });

  function formatToCurrency(number: number | null) {
    if (number !== null) {
      return Euro.format(number / 100);
    }
  }

  if (!upcomingInvoice.data.lines) {
    return <></>;
  }

  return (
    <Wrapper mt={20} title={'Prossima fattura'}>
      {upcomingInvoice?.data?.lines?.data?.map((line) => (
        <div className={'flex justify-between gap-2'}>
          <p>{line.description}</p><p>{formatToCurrency(line.amount_excluding_tax)}</p>
        </div>
      ))}
      {upcomingInvoice?.data?.discounts?.map((discount) => {
        if (typeof discount === 'string') {
          return <></>;
        }
        return (
          <div key={discount.coupon.id} className={'flex justify-between gap-2'}>
            <p>{discount.coupon.name}</p><p>-{formatToCurrency(discount.coupon.amount_off)}</p>
          </div>
        );
      })}
      <div className={'flex justify-between gap-2'}>
        <p>Tasse (IVA 22%)</p><p>{formatToCurrency(upcomingInvoice.data.tax)}</p>
      </div>
      <div className={'flex justify-between mt-2 border-t pt-2 gap-2'}>
        <p className={'font-bold'}>Totale</p><p>{formatToCurrency(upcomingInvoice.data.total)}</p>
      </div>
    </Wrapper>
  );
};
export default UpcomingInvoiceOverview;
